module.exports = __webpack_public_path__ + "img/database.2087dc20.svg";